<!--
 * @Author: your name
 * @Date: 2022-03-31 08:44:19
 * @LastEditTime: 2022-04-06 13:19:41
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \新建文件夹\second\do-network\src\views\pc\tech\TechRoadmapSwiper.vue
-->
<template>
  <div>
    <div class="date-container">
      <div class="date-component active-com">
        <div class="date-quarter">
          <p>{{ Q4 }}</p>
        </div>
        <div class="date-month">{{ Time }}</div>
        <div class="blue-divide"></div>
        <!-- <div class="date-desc">
          {{ TextLeft }}
        </div> -->
        <div class="date-desc" v-html="formattedText"></div>
      </div>
      <div class="myswiper-container">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, index) of dateList" :key="index">
            <div
              class="item-container"
              :class="{ active: index === realIndex }"
            >
              <div class="item-quarter">
                <p>{{ item.quarter }}</p>
              </div>
              <div class="item-month">{{ item.month }}</div>
              <div class="item-blue-divide"></div>
              <div class="item-desc">
                <span>{{ item.tit }}</span
                >{{ item.desc }}
              </div>
              <div class="item-desc">
                <span>{{ item.tit1 }}</span
                >{{ item.desc1 }}
              </div>
              <div class="item-desc">
                <span>{{ item.tit2 }}</span
                >{{ item.desc2 }}
              </div>
              <div class="item-desc">
                <span>{{ item.tit3 }}</span
                >{{ item.desc3 }}
              </div>
              <div class="item-desc">
                <span>{{ item.tit4 }}</span
                >{{ item.desc4 }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="swiper-Button">
        <div
          class="swiper-button-prev"
          slot="button-prev"
          @click="prev"
          :class="{ prev: flag2 === true }"
        ></div>
        <div class="swiper-scrollbar" slot="scrollbar">
          <span :style="{ marginTop: spanMargin + 'px' }"></span>
        </div>
        <div
          class="swiper-button-next"
          slot="button-next"
          @click="next"
          :class="{ prev: flag === true }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.less";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    const _this = this;
    return {
      formattedText: "",
      realIndex: 0, //轮播图滚动当前index
      spanMargin: 0,
      // dateList: [
      //   {
      //     id: 1,
      //     quarter: "Q1",
      //     month: "2025-Q1",
      //     desc: `<b>DeFi Ecosystem Expansion:</b> Enhance financial infrastructure by introducing new projects such as lending platforms, trading platforms, and stablecoins.`,
      //     desc1: `<b>Developer Support:</b> Provide more developer tools and resources, launch or improve SDKs to attract developers to join.`,
      //     desc2: `<b>MEME Ecosystem Expansion:</b> Promote the adoption of MEME tools and protocols to increase user engagement.`,
      //     desc3: `<b>Grant Program:</b> Further promote the existing grant program to support the development of more ecosystem projects.`,
      //     desc4: "",
      //   },
      //   {
      //     id: 2,
      //     quarter: "Q2",
      //     month: "2025-Q2",

      //     desc: `<b>User Education:</b> Launch more educational content to help new users quickly adapt to the DO ecosystem.`,
      //     desc1:
      //       `<b>Cross-Chain Solutions:</b> Improve interoperability with other blockchains and enrich cross-chain experiences.`,
      //     desc2:
      //       `<b>Security and Stability:</b> Optimize the network infrastructure to enhance performance, security, and scalability.`,
      //     desc3:
      //       `<b>NFT Market Expansion:</b> Support more NFT projects, optimize platforms, and expand use cases for art, collectibles, and utility NFTs.`,
      //     desc4:
      //       `<b>Ecosystem Collaboration:</b> Partner with other promising ecosystems for joint events to achieve traffic sharing.`,
      //   },
      //   {
      //     id: 3,
      //     quarter: "Q3",
      //     month: "2025-Q3",
      //     desc: `<b>AI Agent:</b> Launch or support AI applications to leverage DO's speed advantages.`,
      //     desc1:
      //       `<b>Stablecoin Ecosystem:</b> Strengthen integration with traditional finance and expand stablecoin use cases.`,
      //     desc2:
      //       `<b>Market Promotion:</b> Attract more users and developers through marketing and partnerships to promote DO.`,
      //     desc3:
      //       `<b>Technical Optimization:</b> Improve network performance, reduce transaction fees, and increase transaction speed.`,
      //     desc4:
      //       `<b>Infrastructure Integration:</b> Integrate more core features into wallets, browsers, and other foundational tools to improve usability.`,
      //   },
      //   {
      //     id: 4,
      //     quarter: "Q4",
      //     month: "2025-Q4",
      //     desc: `<b>DePin Expansion:</b> Develop and promote decentralized physical infrastructure networks (DePin) to connect the physical world with the DO ecosystem.`,
      //     desc1:
      //       `<b>RWA (Real-World Assets):</b> Launch platforms that support real-world assets, integrating traditional assets such as real estate and artwork into the DO ecosystem.`,
      //     desc2:
      //       `<b>AI Ecosystem Advancement:</b> Further integrate AI technology to enhance its applications in the DO ecosystem, such as automating smart contracts, data processing, and optimizing user experiences.`,
      //     desc3:
      //       `<b>Community Governance and Participation:</b> Increase community engagement through DAO or similar mechanisms, giving the community a greater voice`,
      //     desc4:
      //       `<b>Ecosystem Diversification: </b>Introduce more innovative applications, including but not limited to blockchain solutions in health, education, and logistics, to expand DO's use cases`,
      //   },
      //   // {
      //   //   id:4,
      //   //   quarter:"Q1",
      //   //   month:"Mar 2022",
      //   //   desc:"Combine related modules of the DO Network."
      //   // },
      //   // {
      //   //   id:5,
      //   //   quarter:"Q2",
      //   //   month:"Apr 2022",
      //   //   desc:"Start the capital operation of the DO network."
      //   // },
      //   // {
      //   //   id:6,
      //   //   quarter:"Q2",
      //   //   month:"May 2022",
      //   //   desc:"Start the DO Network test network."
      //   // },
      //   // {
      //   //   id:7,
      //   //   quarter:"Q2",
      //   //   month:"June 2022",
      //   //   desc:"Enter the Test net Ark competition."
      //   // },
      //   // {
      //   //   id:8,
      //   //   quarter:"Q3",
      //   //   month:"Aug 2022",
      //   //   desc:"Launch the main network officially."
      //   // },
      //   // {
      //   //   id:9,
      //   //   quarter:"Q3",
      //   //   month:"Sep 2022",
      //   //   desc:"Launch the DAO Ecological Development Fund."
      //   // },
      //   // {
      //   //   id:10,
      //   //   quarter:"Q4",
      //   //   month:"Oct 2022",
      //   //   desc:"Launch the native autonomy voting for the DO network."
      //   // },
      //   // {
      //   //   id:11,
      //   //   quarter:"Q4",
      //   //   month:"Dec 2022",
      //   //   desc:"Start the autonomous development of open decentralization of the DAO protocol."
      //   // }
      // ],
      dateList: [
        {
          id: 1,
          quarter: "Q1",
          month: "2025-Q1",
          tit: "DeFi Ecosystem Expansion:",
          tit1: "Developer Support:",
          tit2: "MEME Ecosystem Expansion:",
          tit3: "Grant Program:",
          tit4: "",
          desc: " Enhance financial infrastructure by introducing new projects such as lending platforms, trading platforms, and stablecoins.",
          desc1:
            " Provide more developer tools and resources, launch or improve SDKs to attract developers to join.",
          desc2:
            " Promote the adoption of MEME tools and protocols to increase user engagement.",
          desc3:
            " Further promote the existing grant program to support the development of more ecosystem projects.",
          desc4: "",
        },
        {
          id: 2,
          quarter: "Q2",
          month: "2025-Q2",
          tit: "User Education:",
          tit1: "Cross-Chain Solutions:",
          tit2: "Security and Stability:",
          tit3: "NFT Market Expansion:",
          tit4: "Ecosystem Collaboration:",
          desc: " Launch more educational content to help new users quickly adapt to the DO ecosystem.",
          desc1:
            "Improve interoperability with other blockchains and enrich cross-chain experiences.",
          desc2:
            "Optimize the network infrastructure to enhance performance, security, and scalability.",
          desc3:
            "Support more NFT projects, optimize platforms, and expand use cases for art, collectibles, and utility NFTs.",
          desc4:
            "Partner with other promising ecosystems for joint events to achieve traffic sharing.",
        },
        {
          id: 3,
          quarter: "Q3",
          month: "2025-Q3",
          tit: "AI Agent:",
          tit1: "Stablecoin Ecosystem:",
          tit2: "Market Promotion:",
          tit3: "Technical Optimization:",
          tit4: "Infrastructure Integration:",
          desc: " Launch or support AI applications to leverage DO's speed advantages.",
          desc1:
            "Strengthen integration with traditional finance and expand stablecoin use cases.",
          desc2:
            "Attract more users and developers through marketing and partnerships to promote DO.",
          desc3:
            "Improve network performance, reduce transaction fees, and increase transaction speed.",
          desc4:
            "Integrate more core features into wallets, browsers, and other foundational tools to improve usability.",
        },
        {
          id: 4,
          quarter: "Q4",
          month: "2025-Q4",
          tit: "DePin Expansion:",
          tit1: "RWA (Real-World Assets):",
          tit2: "AI Ecosystem Advancement:",
          tit3: "Community Governance and Participation:",
          tit4: "Ecosystem Diversification:",
          desc: " Develop and promote decentralized physical infrastructure networks (DePin) to connect the physical world with the DO ecosystem.",
          desc1:
            " Launch platforms that support real-world assets, integrating traditional assets such as real estate and artwork into the DO ecosystem.",
          desc2:
            " Further integrate AI technology to enhance its applications in the DO ecosystem, such as automating smart contracts, data processing, and optimizing user experiences.",
          desc3:
            " Increase community engagement through DAO or similar mechanisms, giving the community a greater voice",
          desc4:
            " Introduce more innovative applications, including but not limited to blockchain solutions in health, education, and logistics, to expand DO's use cases",
        },
        // {
        //   id: 4,
        //   quarter: "Q1",
        //   month: "Mar 2022",
        //   desc: "Combine related modules of the DO Network.",
        // },
        // {
        //   id: 5,
        //   quarter: "Q2",
        //   month: "Apr 2022",
        //   desc: "Start the capital operation of the DO network.",
        // },
        // {
        //   id: 6,
        //   quarter: "Q2",
        //   month: "May 2022",
        //   desc: "Start the DO Network test network.",
        // },
        // {
        //   id: 7,
        //   quarter: "Q2",
        //   month: "June 2022",
        //   desc: "Enter the Test net Ark competition.",
        // },
        // {
        //   id: 8,
        //   quarter: "Q3",
        //   month: "Aug 2022",
        //   desc: "Launch the main network officially.",
        // },
        // {
        //   id: 9,
        //   quarter: "Q3",
        //   month: "Sep 2022",
        //   desc: "Launch the DAO Ecological Development Fund.",
        // },
        // {
        //   id: 10,
        //   quarter: "Q4",
        //   month: "Oct 2022",
        //   desc: "Launch the native autonomy voting for the DO network.",
        // },
        // {
        //   id: 11,
        //   quarter: "Q4",
        //   month: "Dec 2022",
        //   desc: "Start the autonomous development of open decentralization of the DAO protocol.",
        // },
      ],
      SrcH: false,
      imgHover: "../../../assets/pc/intro/Group 2444@2x.png",
      ImgHover: "../../../assets/pc/intro/Group 2445@2x.png",
      Q4: "Q1", //左侧标题
      Time: "2025-Q1", //左侧时间\
      // TextLeft: `
      //   <b>DeFi Ecosystem Expansion: </b>Enhance financial infrastructure by introducing new projects such as lending platforms, trading platforms, and stablecoins.<br>
      //   <b>Developer Support:</b> Provide more developer tools and resources, launch or improve SDKs to attract developers to join.<br>
      //   <b>MEME Ecosystem Expansion:</b> Promote the adoption of MEME tools and protocols to increase user engagement.<br>
      //   <b>Grant Program:</b> Further promote the existing grant program to support the development of more ecosystem projects.
      // `,
      formattedText:
        "<br/><b>DeFi Ecosystem Expansion: </b>Enhance financial infrastructure by introducing new projects such as lending platforms, trading platforms, and stablecoins.\n\n <b>Developer Support:</b> Provide more developer tools and resources, launch or improve SDKs to attract developers to join.\n \n <b>MEME Ecosystem Expansion:</b> Promote the adoption of MEME tools and protocols to increase user engagement.\n\n <b>Grant Program:</b> Further promote the existing grant program to support the development of more ecosystem projects. ",
      // TextLeft:
      //   "\n EVM launched, supporting ERC721/ERC20 protocols and deployment; \n Smart Contracts - Technical documentation upgraded and open-sourced;\n Ark Wallet upgraded.", //左侧文本
      swiperOption: {
        direction: "vertical",
        // loop: true,
        height: 340,
        observer: true,
        observeParents: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionStart(swiper) {
            // 获取轮播图文本内容
            let dateListLeft = "";
            // dateListLeft = swiper.slides[this.realIndex].innerText+ ";\n";
            dateListLeft = `${swiper.slides[this.realIndex].innerText}`;
            _this.Q4 = dateListLeft.substr(0, 3);
            _this.Time = dateListLeft.substr(3, 9);
            // _this.tits =dateListLeft.substring(11,19);
            _this.TextLeft = dateListLeft.substr(11, dateListLeft.length + 1);
            // 处理 _this.TextLeft 中所有包含 ':' 的部分，将冒号前的内容加粗
            _this.formattedText = _this.TextLeft.split("\n") // 按行分割
              .map((line) => {
                if (line.includes(":")) {
                  const [beforeColon, afterColon] = line.split(":");
                  return `<b>${beforeColon}:</b>${afterColon}`;
                }
                return line; // 保留没有冒号的行
              })
              .join("<br>"); // 使用 <br> 拼接回去，保持换行格式

            // 输出结果（可以直接将 formattedText 用于渲染）
            console.log(_this.formattedText);
            // console.log(_this.TextLeft);
            // const splitText = _this.TextLeft.split(':');
            // _this.formattedText = `<b>${splitText[0]}:</b>${splitText.slice(1).join(':')}`;

            // // 输出结果（可以直接将 formattedText 用于渲染）
            // console.log(_this.formattedText);
            // 获取轮播图的index 动态添加背景演示
            _this.realIndex = this.realIndex;
          },
        },
      },
      flag: false,
      flag2: false,
      timer: null,
    };
  },
  created() {
    if (this.spanMargin === 0) {
      this.flag2 = true;
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    currentSwiperData() {
      //当前slide数据
      return this.swiperList[this.realIndex];
    },
  },
  mounted() {},
  methods: {
    // 向上滑动
    prev() {
      this.$refs.mySwiper.$swiper.slidePrev();
      if (this.spanMargin > 0 && this.spanMargin <= 360) {
        this.spanMargin = this.spanMargin - 120;
        this.flag = false;
      } else if (this.spanMargin <= 0) {
        this.spanMargin = 0;
        this.flag2 = true;
      }
    },
    // 向下滑动
    next() {
      this.$refs.mySwiper.$swiper.slideNext();
      if (this.spanMargin >= 0 && this.spanMargin < 360) {
        this.flag2 = false;
        this.spanMargin = this.spanMargin + 120;
      } else if (this.spanMargin >= 360) {
        this.spanMargin = 360;
        this.flag = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.date-container {
  width: 1200px;
  margin: 0 auto;
  padding-top: 187px;
  position: relative;
}
.date-container {
  display: flex;
  height: 640px;
  margin-top: -60px;
  &:nth-last-child(1) {
    margin-bottom: 425px;
  }
  .myswiper-container {
    flex: 1;
    // margin: 0 30px;
    width: 380px;
    height: 770px;
    overflow: hidden;
    .item-container {
      padding: 0 20px;
      width: 380px;
      // min-height: 70px;
      background: #fafbfd;
      border-radius: 15px;
      margin-bottom: 130px;
      margin-left: 80px;
      display: flex;
      flex-direction: column;
      padding-bottom: 20px;

      .item-quarter {
        width: 67px;
        height: 68px;
        font-size: 45px;
        font-family: Poppins-ExtraBold, Poppins;
        font-weight: 800;
        color: rgba(52, 51, 61, 0.08);
        line-height: 68px;
        -webkit-background-clip: text;
      }
      .item-month {
        height: 68px;
        font-size: 45px;
        font-family: Poppins-ExtraBold, Poppins;
        font-weight: 800;
        color: #34333d;
        line-height: 68px;
        -webkit-background-clip: text;
      }
      .item-blue-divide {
        margin-top: 15px;
        width: 40px;
        height: 4px;
        background: #4573e7;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
      .item-desc {
        margin-top: 10px;
        width: 286px;
        // height: 42px;
        font-size: 14px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #b2b2b2;
        white-space: pre-line;
        line-height: 21px;
        -webkit-background-clip: text;
        span {
          color: #000000;
          font-weight: 800;
        }
      }
    }
    .active {
      background: #eff2f8 !important;
    }
  }
  .date-component::-webkit-scrollbar {
    display: none;
  }
  .date-component {
    width: 620px;
    height: 770px;
    padding: 0 53px;
    border: 3px solid #ffffff;
    border-radius: 30px;
    box-shadow: 0px 22px 51px 1px rgba(46, 87, 192, 0.05);
    background: rgba(251, 251, 251, 0.3);
    overflow-y: auto; /* 启用垂直滚动 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    .date-quarter {
      margin-top: 53px;
      font-size: 60px;
      font-family: Poppins-ExtraBold, Poppins;
      font-weight: 800;
      color: rgba(52, 51, 61, 0.08);

      line-height: 120px;
      -webkit-background-clip: text;
      p {
        height: 90px;
        line-height: 90px;
        font-size: 60px;
        font-family: Poppins-ExtraBold, Poppins;
        font-weight: 800;
        color: rgba(52, 51, 61, 0.08);
        -webkit-background-clip: text;
      }
    }
    .date-month {
      height: 90px;
      font-size: 70px;
      font-family: Poppins-ExtraBold, Poppins;
      font-weight: 800;
      color: #000000;
      line-height: 120px;
      -webkit-background-clip: text;
    }
    .blue-divide {
      margin-top: 27px;
      width: 60px;
      height: 6px;
      background: #4573e7;
    }
    .date-desc {
      margin: 0px 6px 0;
      height: 80px;
      font-size: 18px;
      font-family: Poppins-Regular, Poppins;
      font-weight: 400;
      color: #666;
      line-height: 26px;
      white-space: pre-line;
      -webkit-background-clip: text;
      span {
        color: #000000;
      }
    }
  }
}
.swiper-Button {
  width: 30px;
  height: 528px;
  box-sizing: border-box;
  position: absolute;
  top: 223px;
  right: 28px;
  z-index: 1;
  .swiper-scrollbar {
    width: 6px;
    height: 407px;
    background: rgba(215, 221, 234, 0.3);
    margin: 30px 0 30px 12px;
    span {
      width: 100%;
      height: 37px;
      display: inline-block;
      background: #4573e7;
    }
  }
  .swiper-button-prev {
    width: 30px;
    height: 30px;
    background: url("../../../assets/pc/intro/Group 2444@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .prev {
    pointer-events: none;
  }
  .swiper-button-prev:hover {
    background: url("../../../assets/pc/intro/Group 2445@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    transform: rotate(180deg);
  }
  .swiper-button-next {
    width: 30px;
    height: 30px;
    background: url("../../../assets/pc/intro/Group 2444@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    transform: rotate(180deg);
  }
  .swiper-button-next:hover {
    background: url("../../../assets/pc/intro/Group 2445@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    transform: rotate(0deg);
  }
}
</style>
